import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ReportPointStatusPage } from './report-point-status.page';

const routes: Routes = [
  {
    path: '',
    component: ReportPointStatusPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportPointStatusPageRoutingModule {}
